import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=ab2b9374&scoped=true&lang=less"

import exportComponent from "/Users/yangxinyuan/yxy9022/lit-note/node_modules/.pnpm/vue-loader@17.1.1_vue@3.3.2+webpack@5.82.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab2b9374"]])

export default __exports__